export const LIST_TYPES = {
  MAIN: "Array methods",
  MUTATING: "Mutating",
  NON_MUTATING: "Non mutating",
};
export const TITLE_HEADER = `Let's now a little about methods in JS with React!`;
